import { ReactNode } from 'react'
import { Stack } from '@mui/material'
import Typography from '@mui/material/Typography'

import { HEADER_HEIGHT, PADDING_X } from '@/constants'
import { neutral } from '@/Theme/colors'

import PageHeaderButton from '@/Components/Layout/PageHeaderButton'
import { Row } from '@/Components/Layout/Row'
import { usePage } from '@/Components/Pages/PageProvider'

type PageHeaderProps = {
  title: string
  action: ReactNode
  modelName?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  action: _action,
  modelName
}) => {
  const { setAddingRecord } = usePage()
  let action = _action
  if (modelName && !action) {
    action = (
      <PageHeaderButton onClick={() => setAddingRecord(true)}>
        Create New {modelName}
      </PageHeaderButton>
    )
  }
  return (
    <Stack
      component="header"
      sx={{
        px: PADDING_X,
        backgroundColor: 'primary.main',
        borderBottom: '10px solid',
        borderBottomColor: '#212121',
        height: HEADER_HEIGHT,
        justifyContent: 'center',
        gap: 1
      }}
    >
      <Row alignItems="center" justifyContent="space-between">
        <Typography component="h2" variant="h2" color={neutral}>
          {title}
        </Typography>
        {action}
      </Row>
    </Stack>
  )
}

export default PageHeader
